import axios from "axios"
import { refreshTokenIfNeeded } from "../composables/useAuth"
import { isRefreshing } from "../composables/auth/refreshState"
import { url } from "../helper"

// Create an axios instance with the shared API base URL.
const api = axios.create({
	baseURL: url,
})

// Attach a request interceptor that injects the Authorization header
// with a Bearer token if one is available. This runs before every request.
api.interceptors.request.use(async (config) => {
	// Attempt to obtain a valid access token.
	if (!isRefreshing) {
		const token = await refreshTokenIfNeeded()
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
	}
	return config
})

// Export the configured axios instance so the rest of the app can use it.
export default api
